var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupplies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fa6-solid:hat-cowboy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5003 2.52423C13.0628 2.52423 13.3714 2.24816 13.7034 1.95632C14.0785 1.62109 14.4808 1.26221 15.3128 1.26221C17.2386 1.26221 18.6097 7.26469 19.137 10.0135C17.4925 10.7313 15.2699 11.3584 12.5003 11.3584C9.73079 11.3584 7.50814 10.7313 5.86361 10.0135C6.39095 7.26469 7.76204 1.26221 9.68782 1.26221C10.5199 1.26221 10.9222 1.62109 11.2972 1.95632C11.6292 2.24816 11.9378 2.52423 12.5003 2.52423ZM4.34017 10.6761C6.18392 11.6423 8.93001 12.6204 12.5042 12.6204C16.0785 12.6204 18.8245 11.6423 20.6644 10.6761C21.6331 10.1673 22.6097 9.55998 23.4027 8.79488C23.7113 8.48332 24.1917 8.43205 24.5589 8.66474C24.93 8.89742 25.0863 9.37068 24.9456 9.78872C24.4183 11.2755 23.4456 12.6401 22.3636 13.7562C20.4574 15.732 17.3284 17.6685 12.5003 17.6685C7.6722 17.6685 4.5472 15.732 2.63704 13.7562C1.55501 12.6362 0.582356 11.2716 0.0550122 9.78478C-0.0856128 9.36674 0.0706372 8.89348 0.441731 8.6608C0.812825 8.42811 1.28939 8.48332 1.59798 8.79094C2.39486 9.55604 3.36751 10.1634 4.33626 10.6721L4.34017 10.6761Z",
    fill: "url(#paint0_linear_787_8476)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_787_8476",
    x1: 12.5003,
    y1: 1.26221,
    x2: 12.5003,
    y2: 17.6685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC8E67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECCC1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplies);
export default __webpack_public_path__ + "static/media/supplies.ec72082aa4db7690179c2326d68e6a72.svg";
export { ForwardRef as ReactComponent };